import { DefaultValue } from 'app/components/access-panel/default-values/panel-default-values-utils';
import { FormValuesType } from 'app/infrastructure/simple-form/types';
import { ComplexValue } from 'ui';
import { CodeValue } from './panel-default-values-utils';

export const getDuplicatedValueFields = (
  defaultValue: DefaultValue[],
  formValues: FormValuesType,
  initialDefaultValueFields: CodeValue[]
) => {
  const formCaseTypes = formValues && formValues.defaultValue_caseTypes as ComplexValue<number>;
  const defaultValuesFields = formValues && formValues.defaultValue_valuesFields as ComplexValue<number>[];
  const hasEmptyData = !defaultValue || !formValues || (defaultValue && !defaultValue.length) || !Array.isArray(defaultValue);

  const formValueFields = initialDefaultValueFields && initialDefaultValueFields.length > 0
    ? (defaultValuesFields && defaultValuesFields.filter(f => !initialDefaultValueFields.map(c => c.value).includes(f.value)))
    : defaultValuesFields;

  const defaultValueFields = formValues && formCaseTypes && defaultValue && Array.isArray(defaultValue)
    && [].concat.apply([],
      defaultValue
        .filter(v => v.caseType && v.caseType.value === formCaseTypes.value)
        .map(c => c.defaultValueFields)
    );

  if (!defaultValueFields || hasEmptyData) {
    return undefined;
  }

  return (defaultValueFields && formValueFields
    && defaultValueFields
      .filter(f => formValueFields
        .map(c => c.value)
        .includes(f.value))) || [];
};
